import { CanActivateFn } from '@angular/router';
import { inject } from '@angular/core';
import { Store } from '@ngxs/store';
import { catchError, filter, map, of, switchMap, take, timeout } from 'rxjs';
import { PracticeLocationsState } from 'src/app/states/practice-locations-state.service';
import { FetchPracticeLocations } from 'src/app/states/practice-locations.actions';
import { PreaccessioningService } from 'src/shared/services/preaccessioning.service';
import { NavigateToForbidden } from 'src/app/states/navigations.actions';

export const preaccessionManifestsDependenciesGuard: CanActivateFn = () => {
  const store = inject(Store);
  const preaccessioningService = inject(PreaccessioningService);

  return preaccessioningService.isPreAccessioningEnabled$.pipe(
    take(1),
    switchMap(isEnabled => {
      // Preaccessioning is not enabled for this account; direct links (e.g. bookmarks) go to Forbidden instead of a blank page.
      if (!isEnabled) {
        return store.dispatch(new NavigateToForbidden()).pipe(map(() => false));
      }

      if (!store.selectSnapshot(PracticeLocationsState.loaded)) {
        store.dispatch(new FetchPracticeLocations());
      }

      return store.select(PracticeLocationsState.practiceLocations).pipe(
        filter(value => !!value),
        map(() => true),
        timeout(30000),
        take(1),
        catchError(() => of(false))
      );
    })
  );
};
